import { render, staticRenderFns } from "./ModalAuthenticator.vue?vue&type=template&id=3b6ce313&"
import script from "./ModalAuthenticator.vue?vue&type=script&lang=js&"
export * from "./ModalAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports